module.exports = new __parcel__URL__("qr.39fb77b5.png").toString();